import { Heading } from '@findy-code/yuffie/ui/heading';

import styles from './company-detail-related-links.component.module.scss';
import { SectionLayout } from './section-layout.component';

type Props = {
  relatedLinks: { name: string; url: string; id: number }[];
};

export const CompanyDetailRelatedLinks = ({ relatedLinks }: Props) => {
  return (
    <SectionLayout heading={{ title: '関連リンク' }} id="links">
      <div className={styles.relatedLinksBlock}>
        {relatedLinks.map((relatedLink) => (
          <a /* 外部リンクなので <Link> ではなく <a> */
            className={styles.itemAnchor}
            href={relatedLink.url}
            key={relatedLink.id}
            rel="noopener"
            target="_blank"
          >
            <Heading as="h4" className={styles.itemTitle} font="heading-m">
              {relatedLink.name}
            </Heading>
            <div className={styles.itemUrl}>{relatedLink.url}</div>
          </a>
        ))}
      </div>
    </SectionLayout>
  );
};
